const styles = {

  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 80,
    '& .Icon-container': {
      filter: 'grayscale(1)',
    },
    '&.selected': {
      '& .Icon-container': {
        filter: 'grayscale(0)',
      },
    },

  },

  iconContainer: {
    position: 'relative',
    width: { xs: 20, lg: 25 },
    height: { xs: 20, lg: 25 },
  },

}

export default styles
